import { faMap } from "@fortawesome/free-regular-svg-icons";
import { faList, faTableCells } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useConnector } from "react-instantsearch";
import { CloseButton } from "../components/CloseButton";
import { ListHit } from "./ListHit";
import { TileHit } from "./TileHit";

export type HitType = "list" | "map" | "grid";

export type HitComponentType = ({ hit }) => JSX.Element;
export const HitMapping: Record<HitType, [HitComponentType, string]> = {
  list: [ListHit, "w-full m-1 p-4"],
  grid: [TileHit, "inline-block box-content p-4 m-1 w-32 lg:w-52"],
  map: [null, ""],
};

const connectMode = (renderFn, unmountFn) => {
  return () => {
    return {
      $$type: "ca_project.mode",
      render(renderOptions) {
        const { helper, state, widgetParams, instantSearchInstance } = renderOptions;
        renderFn(
          {
            mode: state.mode || "grid",
            setMode: (value: HitType) => {
              helper.setQueryParameter("mode", value).search();
            },
            widgetParams,
            instantSearchInstance,
          },
          false
        );
      },
      getWidgetRenderState(renderOptions) {
        const { helper, state, widgetParams, instantSearchInstance } = renderOptions;
        return {
          mode: state.mode || "grid",
          setMode: (value: HitType) => {
            helper.setQueryParameter("mode", value).search();
          },
          widgetParams,
          instantSearchInstance,
        };
      },
      dispose() {
        unmountFn();
      },
      getWidgetUiState(uiState, { searchParameters }) {
        const mode = searchParameters.mode;
        if (mode && mode !== "grid") {
          return {
            ...uiState,
            mode,
          };
        }
        return uiState;
      },
      getWidgetSearchParameters(searchParameters, { uiState }) {
        return searchParameters.setQueryParameter("mode", uiState.mode || "grid");
      },
    };
  };
};

interface ModeConnectorProps {
  mode: HitType;
  setMode: (value: HitType) => void;
}
export function useMode(props?: any): ModeConnectorProps {
  // @ts-ignore
  return useConnector(connectMode, props);
}

const StateBtn = ({
  active,
  activate,
  attr,
  title,
  icon,
  className,
}: {
  active: HitType;
  activate: (s: HitType) => void;
  attr: HitType;
  title: string;
  icon: any;
  className?: string;
}) => {
  className = (className || "") + (active === attr ? " bg-green" : " bg-dark-green");
  return (
    <button
      type="button"
      onClick={() => activate(attr)}
      title="Kaart"
      className={`inline-flex items-center py-2 text-sm font-medium text-white text-center hover:text-yellow/90 p-2 ${className}`}
    >
      <FontAwesomeIcon
        icon={icon}
        fill="currentColor"
        aria-hidden="true"
        className="w-3 h-3 pr-1"
      />
      {title}
    </button>
  );
};

export const Header = () => {
  const { mode = "grid", setMode } = useMode();

  return (
    <>
      <div className="pt-11 block w-full"></div>
      <div className="pt-2 flex fixed top-14 lg:w-84 z-100 bg-white">
        <button className="inline-flex p-2 text-sm font-medium  bg-bright-yellow text-black rounded-md mr-3 hover:text-dark-green hover:bg-yellow-light">
          Reset
        </button>

        <div className="inline-flex rounded-md shadow-xs" role="group" aria-label="">
          <StateBtn
            active={mode}
            activate={setMode}
            attr="map"
            title="Kaart"
            icon={faMap}
            className="rounded-s-lg"
          />
          <StateBtn active={mode} activate={setMode} attr="list" title="Lijst" icon={faList} />
          <StateBtn
            active={mode}
            activate={setMode}
            attr="grid"
            title="Foto's"
            icon={faTableCells}
            className="rounded-e-lg"
          />
        </div>
        <CloseButton className="text-black hover:text-gray hover:bg-black" />
      </div>
    </>
  );
};
